<template>
  <OrderGantt>
    <Header ref="header" slot="header" />
  </OrderGantt>
</template>
<script>
import Header from './header.vue'
import OrderGantt from '@/views/factory/components/order-gantt'
export default {
  components: { Header, OrderGantt },
}
</script>
